$(function(){
  $('a[href^="#"]').not('.jdgm-write-rev-link').click(function(){
  	var adjust = 0;
    //スクロールのスピード
    var speed = 500;
    //リンク元を取得
    var href= $(this).attr("href");
    //リンク先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    //リンク先までの距離を取得
    var position = target.offset().top + adjust;
    //スムーススクロール
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});


//pagetop
$(function() {
    var topBtn = $('#page-top');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function() {
        if ($(this).scrollTop() > 1000) {
            //ボタンの表示方法
            topBtn.fadeIn();
        } else {
            //ボタンの非表示方法
            topBtn.fadeOut();
        }
    });
});


//Judge.meのスクロール後にヘッダー分を補正する共通処理
//対象：「レビューを書く」ボタン、レビュー件数バッジ
//Judge.me側がstopPropagationするため、captureフェーズで拾っている
function jdgmScrollAdjust() {
  var lastY = window.scrollY;
  var stableCount = 0;
  var elapsed = 0;

  var timer = setInterval(function() {
    elapsed += 25;

    if (window.scrollY === lastY) {
      stableCount++;
    } else {
      stableCount = 0;
      lastY = window.scrollY;
    }

    //スクロールが50ms止まったら完了とみなす
    if (stableCount >= 2 || elapsed > 3000) {
      clearInterval(timer);
      var header = document.querySelector('.header-wrapper');
      var headerHeight = header ? header.offsetHeight : 0;
      //▼余白：989px以下=SP、990px以上=PC
      var gap = window.innerWidth < 990 ? 0 : 5;
      window.scrollBy({ top: -headerHeight - gap, behavior: 'auto' });
    }
  }, 50);
}

document.addEventListener('click', function(e) {
  if (e.target.closest('.jdgm-write-rev-link') || e.target.closest('.jdgm-prev-badge')) {
    jdgmScrollAdjust();
  }
}, true);